module.exports = __webpack_public_path__ + "public/img/Strategi Komunikasi Pelanggan Untuk Customer Service.3ceaab0a.png";